import { css } from '@emotion/react';
import { tokens } from '../tokens';
export function headerStyle(_a) {
    var alignCenter = _a.alignCenter, mode = _a.mode;
    return css({
        padding: mode === 'decorative'
            ? "38px ".concat(tokens.spacing.large, " ").concat(tokens.spacing.medium)
            : "".concat(tokens.spacing.large, " 48px ").concat(tokens.spacing.medium, "\n          ").concat(alignCenter ? '48px' : tokens.spacing.large),
    });
}
export var bodyStaticStyle = css({
    paddingLeft: tokens.spacing.large,
    paddingRight: tokens.spacing.large,
});
export var footerStaticStyle = css({
    padding: "".concat(tokens.spacing.medium, " ").concat(tokens.spacing.large, "\n    ").concat(tokens.spacing.large, " ").concat(tokens.spacing.large),
});
